import { render, staticRenderFns } from "./AddBuyerReturn.vue?vue&type=template&id=03a909e5&scoped=true&"
import script from "./AddBuyerReturn.vue?vue&type=script&lang=js&"
export * from "./AddBuyerReturn.vue?vue&type=script&lang=js&"
import style0 from "./AddBuyerReturn.vue?vue&type=style&index=0&id=03a909e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a909e5",
  null
  
)

export default component.exports